
import { Col, Row } from "react-bootstrap";


export default function AdminPage2 () {
    return (
        <div className="overflow-auto" style={{width:'100%'}}>
            <div className="container flex-grow">
                <Row>
                    <Col>
                        <h2>YES</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <img src="https://picsum.photos/400"></img>
                    </Col>
                </Row>
            </div>
        </div>
    )
}